export const addHubspotTracking = () => {
  const script = document.createElement('script');
  script.src = '//js.hs-scripts.com/4959747.js';
  script.async = true;
  script.defer = true;
  script.id = 'hs-script-loader';
  return script;
};
